<template>
    <div>
        <div style="width: 100vw;height: 28rem; overflow-y: scroll;">
        <div class="camerabox" v-for="(item,input) in cameralist"  @click="$router.push({
         name: 'Merchandise_page',
         params:{ name:item.name}})"> 
            <img :src="item.img" alt="" srcset="">
            <div style="color: #fff;font-size: 0.4rem;width: 100%;text-align: center;">{{item.name}}</div>
        </div>
        </div>
    </div>
</template>
<script>
import camera1 from '../img/camera1.png'
import camera2 from '../img/camera2.png'
import camera4 from '../img/camera4.png'
import camera5 from '../img/camera5.png'
import camera6 from '../img/camera6.png'
import camera8 from '../img/camera8.png'
import camera9 from '../img/camera9.png'
import camera10 from '../img/camera10.png'
import camera11 from '../img/camera11.png'
export default{
    name:"smartcameraseries",
    data() {
        return {
         cameralist:[{img:camera1,name:'LS-M9'},{img:camera2,name:'LS-M10'},{img:camera4,name:'L93/L932'}
         ,{img:camera5,name:'LS-M1'},{img:camera6,name:'LS-97P'},{img:camera8,name:'LS-EP3'},{img:camera9,name:'LS-EP1'},
         {img:camera10,name:'L98E'},{img:camera11,name:'L98A/L98B'}
        ]   
        }
    },
}
</script>
<style scoped>

.camerabox{
    cursor: pointer;
    width: 6vw;
    height: 10rem;
    padding-top: 2rem;
    display: inline-block;
    padding-left: 2vw;
    padding-right: 2vw;
}
.camerabox img:hover{
    background-color: #ffffff42;
}
.camerabox img{
    width: 6vw;
    height: 6vw;
}
@media screen and (max-width: 600px) {
    .camerabox{
    cursor: pointer;
    width: 20vw;
    height: 10rem;
    padding-top: 2rem;
    display: inline-block;
    padding-left: 2vw;
    padding-right: 2vw;
}
.camerabox img:hover{
    background-color: #ffffff42;
}
.camerabox img{
    width: 20vw;
    height: 20vw;
}
}
</style>